// @flow

export default (hostname: string) =>
  /\.co\.nz$/i.test(hostname) ? 'NZ' : 'AU';
